<template>
  <div class="problem-input">
    <el-input
      ref="inputRef"
      v-model="innerValue"
      type="textarea"
      :rows="rows"
      :placeholder="placeholder"
      resize="none"
      maxlength="500"
      spellcheck="false"
      class="problem-input__textarea"
      @keydown.ctrl.enter="handleSubmit"
    />
    <div class="problem-input__footer">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onBeforeUnmount } from 'vue'

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: '先简单描述你的技术问题，一句话也可以。' },
  debounce: { type: Number, default: 600 },
  rows: { type: Number, default: 4 }
})

const emit = defineEmits(['update:modelValue', 'change', 'submit'])

const innerValue = ref(props.modelValue)
const inputRef = ref(null)
let debounceTimer = null

// 外部 v-model 同步
watch(() => props.modelValue, (v) => {
  if (v !== innerValue.value) innerValue.value = v
})

// 内部输入变化：同步 v-model + 防抖触发 change
watch(innerValue, (v) => {
  emit('update:modelValue', v)
  if (debounceTimer) clearTimeout(debounceTimer)
  debounceTimer = setTimeout(() => {
    emit('change', v)
  }, props.debounce)
})

function handleSubmit() {
  emit('submit', innerValue.value)
}

function focus() {
  inputRef.value?.focus?.()
}

defineExpose({ focus })

onBeforeUnmount(() => {
  if (debounceTimer) clearTimeout(debounceTimer)
})
</script>

<style scoped lang="scss">
.problem-input {
  position: relative;
  width: 100%;

  &__textarea {
    :deep(.el-textarea__inner) {
      font-size: 16px;
      line-height: 1.6;
      border-radius: 12px;
      padding: 14px 48px 14px 16px;
      background: #fff;
      border: 1px solid #e4e7ed;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);

      &:focus {
        border-color: var(--el-color-primary);
      }
    }
  }

  &__footer {
    position: absolute;
    right: 14px;
    bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }
}
</style>
